<template>
  <div>
    <div  class="welcome">
      <el-row :gutter="4">
        <el-col :span="8"></el-col>
        <el-col :span="11">
          <div style="font-size: 30px;color: white;">{{ pageTitle }}</div>
        </el-col>
        <el-col :span="5">
          <el-menu mode="horizontal">
            <el-sub-menu index="1">
              <template #title>
                <div style="font-size: 20px;border-bottom-color: transparent;">欢迎 {{ loginNickName }}</div>
              </template>
              <el-menu-item @click="handleToPage('/')" index="home">首页</el-menu-item>
              <el-menu-item  @click="handleToTryPractice('/fire/normal/practice/theoryMediumDevice','normal', 'practice','theory')" index="theoryPractice">理论练习</el-menu-item>
              <el-menu-item  @click="handleToTryPractice('/fire/normal/exam/theoryMediumDevice','normal', 'exam','theory')" index="theoryExam">模拟理论考试</el-menu-item>
              <el-menu-item  @click="handleToTryPractice('/fire/normal/practice/peopleMediumDevice','normal', 'practice','people')" index="peoplePractice">操作题练习</el-menu-item>
              <el-menu-item @click="handleToTryPractice('/fire/normal/exam/peopleMediumDevice','normal', 'exam','people')" index="peopleExam">操作题考试</el-menu-item>

            </el-sub-menu>
          </el-menu>
        </el-col>
      </el-row>
    </div>

    <div>
      <el-row >
        <!--        <el-col :span="1"></el-col>-->
        <el-col :span="8" v-for="subjectInfo in subjectInfos" :key="subjectInfo.id">
          <el-card class="card-container">
            <div class="content">
              <img :src="require(`@/assets/${subjectInfo.imagePath}`)" :alt="subjectInfo.name" style="width: 150px;height: 150px">
              <div style="width: 80px"></div>
              <div>
                <p style="font-size: 20px; font-weight: bold">{{ subjectInfo.name }}</p>
                <p style="font-size: 14px;color: gray">{{ subjectInfo.description }} </p>
                <p style="font-size: 14px;color: gray" v-if="subjectInfo.status!=='introduce'" >已有{{subjectInfo.viewCount}}人练习, 正确率{{ subjectInfo.accuracy }}</p>
                <p style="font-size: 14px;color: gray" v-if="subjectInfo.status==='introduce'" >已有{{subjectInfo.viewCount}}人查看, 准确率 100%</p>
                <el-link style="float: right; padding: 3px 0;font-size: 16px;color: dodgerblue" @click="getPaperInfo(subjectInfo.id)" v-if="subjectInfo.status!=='introduce'">详情 >></el-link>
                <el-link style="float: right; padding: 3px 0;font-size: 16px;color: dodgerblue" @click="goIntroducePage(subjectInfo.id)" v-if="subjectInfo.status==='introduce'">详情 >></el-link>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row >
        <el-col :span="1"></el-col>
        <el-col :span="22">
          <el-card  class="card-container" v-for="paperInfo in paperInfos" :key="paperInfo.id" shadow="hover">
            <div class="content" style="width: 100%;">
              <div class="content">
                <img :src="require(`@/assets/picture/FireEngine/paperTheoryFile.png`)" alt="file" style="width: 60px;height: 80px"/>
                <div style="width: 80px"></div>
                <div>
                  <p style="font-size: 20px; font-weight: bold">{{ paperInfo.name }}</p>
                  <p style="font-size: 14px;color: gray" v-if="paperInfo.status !=='introduce'" >年份:{{paperInfo.year}} - 共{{paperInfo.viewCount}}人练习,正确率{{ paperInfo.accuracy }}
                    ,难度系数:<img :src="require(`@/assets/picture/starLevel/star${paperInfo.starLevel}.png`)" alt="star" style="height: 20px"/></p>
                  <el-link style="float: right; padding: 3px 0;font-size: 16px;color:dodgerblue" @click="getPaperDetailInfo(paperInfo.id, paperInfo.status)" >试卷 >></el-link>
                </div>
              </div>
              <div style="width: 100px">
                <img v-if="paperInfo.status==='lock'" :src="require(`@/assets/picture/lock/lock.png`)" alt="lock" style="width: 100px">
              </div>
              <div>
                <div v-if="checkIfCurrentPaperId(paperInfo.id)">
                  <el-row  v-for="paperDetailInfo in paperDetailInfos" :key="paperDetailInfo.id" style="border-bottom: 1px solid #ebeef5;padding-bottom: 20px;">
                    <el-col :span="16">
              <span style="font-size: 16px; font-weight: bold">{{paperDetailInfo.name}}:
              </span>
                      <span style="font-size: 14px;color: gray" v-if="paperInfo.status==='active' ||paperInfo.status==='randomExam'">     共{{paperDetailInfo.totalCount}}题 </span>
                      <span style="font-size: 14px;color: gray" >{{paperDetailInfo.perScore}}分/题</span>
                    </el-col>
                    <el-col :span="4"></el-col>
                    <el-col :span="4">
                      <el-button type="primary" round @click="goPractice(paperInfo.id, paperDetailInfo.type, paperInfo.name)" v-if="paperDetailInfo.status!=='lock'">立刻练习</el-button>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
          </el-card>

        </el-col>
      </el-row>
    </div>


  </div>
</template>

<script>
import router from "@/router";
import {onMounted, ref} from "vue";
import request from "@/utils/request";
import { useRoute } from 'vue-router'
import { ElMessage } from 'element-plus';

const loginNickName = localStorage.getItem("loginNickName");
const loginUserId = localStorage.getItem("loginUserId");

const pageTitle = ref('');
const selectedPaperId= ref('');
const areaId= ref('');
function getPaperDetailInfo(paperId){
  request.get('/paperDetailInfo/',
      {params: {
          userId: loginUserId, paperId: paperId
        }})
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          selectedPaperId.value=paperId;
          this.paperDetailInfos = result.data;
        } else {
          ElMessage.warning(result.msg);
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}
function updatePaperInfo(paperId) {
  request.put('/paperInfo/updateViewCount',
      {
          paperId: paperId
        })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code !== "200") {
          ElMessage.warning(result.msg);
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}
function getPaperInfo(subjectId) {
  request.get('/paperInfo/subjectId',
      {params: {
          userId: loginUserId, subjectId: subjectId
        }})
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          this.paperInfos = result.data;
        } else {
          ElMessage.warning(result.msg);
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

function getSubjectInfos(buyMode, areaId, studyMode, subjectType) {
  request.post('/subjectInfo/',
      {userId: loginUserId, buyMode: buyMode, areaId: areaId, studyMode: studyMode, type: subjectType})
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code === "200") {
          this.subjectInfos = result.data;
          return;
        }

        if (result.code === "403") {
          ElMessage.warning(result.msg);
          router.push("/buyPage");
        } else{
          ElMessage.warning(result.msg);
          router.push("/login");
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

function updateSubjectInfos(subjectId) {
  request.put('/subjectInfo/updateViewCount',
      {subjectId: subjectId})
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code !== "200") {
          ElMessage.warning(result.msg);
        }
      })
      .catch(error => {
        console.log("TheoryMediumDevice error:" + error);
        // ElMessage.error("系统异常，请联系管理员");
      });
}

export default {
  name: "PeopleMediumDevicePracticeNormal",
  setup() {

    onMounted(async () => {
      pageTitle.value = document.title.replace("助习 - ", "");

    });
  },
  created() {
    const route = useRoute()
    areaId.value=route.query.areaId;
    this.getSubjectInfo(route.query.areaId, route.query.studyMode, route.query.buyMode, route.query.subjectType);
  },
  data() {
    return {
      loginNickName: loginNickName,
      pageTitle: pageTitle,
      subjectInfos:[],
      paperInfos:[],
      paperDetailInfos:[],
      selectedPaperId:selectedPaperId,
    }
  },
  methods: {
    handleToPage(path) {
      router.push(path);
    },
    handleToTryPractice(trainPath, buyMode, studyMode,subjectType) {
      router.push({
        path: trainPath,
        query: {
          areaId: areaId.value,
          studyMode: studyMode,
          buyMode: buyMode,
          subjectType: subjectType
        }
      });
    },
    getSubjectInfo(areaId,studyMode,buyMode,subjectType){
      getSubjectInfos.call(this, buyMode, areaId, studyMode, subjectType);

    },
    getPaperInfo(subjectId){
      getPaperInfo.call(this,subjectId);
      updateSubjectInfos.call(this,subjectId);
    },
    goIntroducePage(subjectId){
      window.open('/#/pages/news/PageContentInfo?areaId='+areaId.value+'&type=introduce_'+subjectId,'_blank');
    },
    getPaperDetailInfo(paperId, paperStatus){
      if(paperStatus !=='lock'){
        getPaperDetailInfo.call(this,paperId);
        updatePaperInfo.call(this, paperId);
      } else {
        ElMessage.warning("此试卷为锁定状态，请先购买对应的产品");
        router.push("/buyPage")
      }
    },
    checkIfCurrentPaperId(paperId){
      return selectedPaperId.value===paperId
    },
    goPractice(paperId,questionType){
      router.push({path:'/fire/peoplePaperPractice',query:{paperId: paperId, questionType: questionType, questionNumber:1, areaId:areaId.value}});
    }
  }
}
</script>

<style scoped>
.mode-col {
  height: 300px;
  width: 400px; /* 设置一个高度让背景显示出来 */
  background-size: contain;
  background-repeat: no-repeat; /* 背景图片覆盖整个元素 */
  transition: background-image 0.5s; /* 可选的，背景图变化过渡效果 */
  align-content: center;
  /*background-color: lightgray;*/
}

.welcome {
  /*background-image: url("../../assets/picture/FireEngine/fireHeader.png");*/
  background-color: blue;
}

.el-menu {
  background-color: transparent;
  border-bottom-color: transparent;
}

.el-menu-item {
  background-color: transparent !important;
  color: black !important;
  font-weight: 50;
  width: 200px;
  font-size: 18px;
  text-align: center;
&:not(.is-disabled):hover {
   color: gray !important;
   background-color: lightgray !important;
   width: 200px;
   text-align: center;
 }
}
.card-container {
  display: flex;
  align-items: center; /* 垂直居中 */
}
.content {
  flex: 1; /* 让内部容器充满剩余空间 */
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: flex-start; /* 水平方向从左边开始排列 */
}
</style>
